/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize SchedulingAlert List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './SchedulingAlertListView';

export const mapStateToPropsSchedulingAlertList = mapStateToProps;
export const mapDispatchToPropsSchedulingAlertList = mapDispatchToProps;

export default connect(
  mapStateToPropsSchedulingAlertList,
  mapDispatchToPropsSchedulingAlertList
)(View);
